import React, { useEffect, useState } from "react";
import axiosInstance from "../services/axiosComman";
import { toast } from "react-toastify";

function CommonXlsExport({
  id,
  path,
  name,
  visible = false,
  onClose = () => {},
}) {
  const [filePath, setFilePath] = useState("");
  // const [fileLoction, setFileLoction] = useState("")

  const CloseFunction = () => {
    toast.success(
      <p className="test-sm">{`${"Data Successfully Exported"}`}</p>
    );
    onClose();
  };

  const fetchFilePath = async (fileLoction) => {
    try {
      const response = await fetch(`${fileLoction}`);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setFilePath(url);
    } catch (error) {
      console.error("Error fetching file:", error);
    }
  };

  const handleDownload = async () => {
    await axiosInstance.get(`/export/${path}/${id}`).then((response) => {
      if (response.data.status) {
        fetchFilePath(response.data.data);
      }
    });
  };

  useEffect(() => {
    if (filePath !== "") {
      const downloadLink = document.createElement("a");
      downloadLink.href = filePath;
      downloadLink.download = `${name}`;
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      CloseFunction();
    }
  }, [filePath]);

  if (!visible) return null;
  return (
    <>
      <div
        id="modal"
        className="bg-black bg-opacity-30 fixed z-10 inset-0 backdrop-blur-sm 
        flex justify-center items-center "
      >
        <div className="bg-white mt-12 p-2 px-4 rounded-xl w-4/12">
          <p className=" my-2 text-center font-medium text-xl 2xl:text-2xl">
            Are You sure?
          </p>
          <p className=" my-2 text-center text-sm 2xl:text-base">
            You want export {name}?
          </p>
          <div className=" w-full py-3 flex justify-center items-center gap-x-6">
            <button
              className=" py-1 px-6 rounded-md bg-primary text-white text-sm 2xl:text-base"
              onClick={handleDownload}
            >
              Yes
            </button>
            <button
              className=" py-1 px-3 rounded-md bg-slate-300 text-slate-800 text-sm 2xl:text-base"
              onClick={onClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}

export default CommonXlsExport;
